import { Index } from "elasticlunr";
import { useEffect, useRef, useState } from "react";

export const useSearch = (index: any, query: string): any[] => {
	const [results, setResults] = useState([]);

	const indexRef = useRef(Index.load(index));

	useEffect(() => {
		setResults(indexRef.current ? indexRef.current.search(query, { expand: true } as any).map(({ ref }) => indexRef.current.documentStore.getDoc(ref)) : []);
	}, [query]);

	return results;
};
